import React from 'react'
import { Container, FormField, Header, Input, SpaceBetween, Textarea } from "@amzn/awsui-components-react-v3";
import { Controller } from "react-hook-form";

export default function MiscInfo(props: any) {
  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Some additional information"
        >
          Miscellaneous information
        </Header>
      }
    >
      <SpaceBetween size="l">

        <SpaceBetween size="s" direction="horizontal">
          <FormField label="Expected number of users in next 12 months" errorText={props.errors?.expected_users_in_year?.message?.toString()}>
            <Controller
              name="expected_users_in_year"
              rules={{
                required: "Required field",
                min: {
                  value: 0,
                  message: "cannot have negative number"
                },
                max: {
                  value: 7753000000000,
                  message: "cannot be more than earth's population"
                }
              }}
              control={props.control}
              defaultValue=""
              render={({ field: { onBlur, onChange, value } }) => (
                <Input type="number" value={value} onChange={({ detail }) => {
                  onChange(detail.value);
                }}
                  onBlur={onBlur} />
              )} />
          </FormField>
        </SpaceBetween>
        <FormField label="Additional comments (optional)" errorText={props.errors?.comments?.message?.toString()}>
          <Controller
            name="comments"
            rules={{
              required: false,
              maxLength: {
                value: 128,
                message: "Maximum accepted length is 1024 characters"
              },
              pattern: {
                value: /^[a-zA-Z\d-_\s.]+$/,
                message: "Only alphanumeric, comma, period, space and hyphen allowed"
              }
            }}
            control={props.control}
            defaultValue=""
            render={({ field: { onChange, value, onBlur } }) => (
              <Textarea
                value={value}
                onBlur={onBlur}
                onChange={({ detail }) => {
                  onChange(detail.value);
                }}
                placeholder="Any additional comments that you have" />
            )} />
        </FormField>
      </SpaceBetween>
    </Container>
  );
}
